
export const sFechaPublicacion = '2025-12-22T16:08:29.6858139-06:00';
export const sVersion = 'vf1.1.512221608';
            